import React, { useEffect, useRef, useState } from 'react';
// import { Icons } from '@/components/icons';
// import { Button } from '@/components/ui';
import { FAQs } from '@/config/recharge';
import { PlusIcon } from 'lucide-react';

export default function PricingFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className='w-full max-w-5xl mx-auto py-[10vh] flex flex-col gap-2 items-center'>
      <div className='w-full flex flex-col items-start mb-4 gap-2'>
        <p className='text-xs text-jen-content-tertiary font-secondary'>FAQ&apos;S</p>
        <h3 className='text-2xl'>Need to know more?</h3>
      </div>
      {FAQs.map((faq, index) => (
        <div key={index} className="w-full ">
          <div
            className={`flex flex-col justify-between items-start cursor-pointer p-6 rounded-lg border-[1px] border-jen-border bg-jen-background-secondary transition duration-200 ${openIndex === index ? 'bg-white' : ''} `}
            onClick={() => toggleFAQ(index)}
          >
            <div className="flex justify-between items-center w-full">
              <h3 className="text-lg text-[22px] pr-4">{faq.question}</h3>
              <div className={`transform transition-transform duration-200 ${openIndex === index ? 'rotate-[135deg]' : ''}`}>
                {/* <Icons.Plus className="transform transition-transform" /> */}
                <PlusIcon />
              </div>
            </div>
            <div
              className={`overflow-hidden overflow-y-scroll transition-all duration-500 ease-in-out flex flex-col items-start ${openIndex === index ? 'max-h-[30rem] mt-4' : 'max-h-0'
                }`}
            >
              <div className='text-md !leading-[150%] text-jen-content-secondary mt-6' dangerouslySetInnerHTML={{ __html: faq.answer || '' }} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}